import { IActivityLocation, IPoiFilterPanelOptions, MapPointTypes } from '@curbnturf/entities';
import { DateTime } from 'luxon';
import { IDataItem } from '../data-item.interface';

export function makeDataPoint(item: IDataItem, type: MapPointTypes): H.clustering.DataPoint {
  return new H.clustering.DataPoint(item.lat, item.lon, undefined, {
    type: type,
    poiType: item.poiType,
    price: item.price,
    id: item.id,
    selected: item.selected,
    multisite: item.multisite,
    expires: DateTime.now().plus({ minutes: 15 }).toSeconds(),
  });
}

export function flattenPoiDataItem(
  activities: IActivityLocation[],
  mapActivityFilters?: IPoiFilterPanelOptions,
): IDataItem[] {
  return activities.reduce((pois, poi) => {
    if (poi.categoryDump && (!mapActivityFilters || mapActivityFilters.dump)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'dump',
      });
    }
    if (poi.categoryRestArea && (!mapActivityFilters || mapActivityFilters?.restArea)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'restArea',
      });
    }
    if (poi.categoryWifi && (!mapActivityFilters || mapActivityFilters?.wifi)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'wifi',
      });
    }
    if (poi.categoryPotableWater && (!mapActivityFilters || mapActivityFilters?.potableWater)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'potableWater',
      });
    }
    if (poi.categoryPropane && (!mapActivityFilters || mapActivityFilters?.propane)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'propane',
      });
    }
    if (poi.activityBiking && (!mapActivityFilters || mapActivityFilters?.activities?.biking)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'biking',
      });
    }
    if (poi.activityBoating && (!mapActivityFilters || mapActivityFilters?.activities?.boating)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'boating',
      });
    }
    if (poi.activityFishing && (!mapActivityFilters || mapActivityFilters?.activities?.fishing)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'fishing',
      });
    }
    if (poi.activityGolf && (!mapActivityFilters || mapActivityFilters?.activities?.golf)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'golf',
      });
    }
    if (poi.activityHiking && (!mapActivityFilters || mapActivityFilters?.activities?.hiking)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'hiking',
      });
    }
    if (poi.activityHorseback && (!mapActivityFilters || mapActivityFilters?.activities?.horseback)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'horseback',
      });
    }
    if (poi.activityHunting && (!mapActivityFilters || mapActivityFilters?.activities?.hunting)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'hunting',
      });
    }
    if (poi.activityKayaking && (!mapActivityFilters || mapActivityFilters?.activities?.kayaking)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'kayaking',
      });
    }
    if (poi.activityMotorSports && (!mapActivityFilters || mapActivityFilters?.activities?.motorSports)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'motorSports',
      });
    }
    if (poi.activityOhv && (!mapActivityFilters || mapActivityFilters?.activities?.ohv)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'ohv',
      });
    }
    if (poi.activityRafting && (!mapActivityFilters || mapActivityFilters?.activities?.rafting)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'rafting',
      });
    }
    if (poi.activityRockClimbing && (!mapActivityFilters || mapActivityFilters?.activities?.rockClimbing)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'rockClimbing',
      });
    }
    if (poi.activitySnowSports && (!mapActivityFilters || mapActivityFilters?.activities?.snowSports)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'snowSports',
      });
    }
    if (poi.activitySurfing && (!mapActivityFilters || mapActivityFilters?.activities?.surfing)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'surfing',
      });
    }
    if (poi.activitySwimming && (!mapActivityFilters || mapActivityFilters?.activities?.swimming)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'swimming',
      });
    }
    if (poi.activityWaterSports && (!mapActivityFilters || mapActivityFilters?.activities?.waterSports)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'waterSports',
      });
    }
    if (poi.activityWildlifeWatching && (!mapActivityFilters || mapActivityFilters?.activities?.wildlifeWatching)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'wildlifeWatching',
      });
    }
    if (poi.activityWindSports && (!mapActivityFilters || mapActivityFilters?.activities?.windSports)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'windSports',
      });
    }
    if (poi.customActivity && (!mapActivityFilters || mapActivityFilters?.activities?.custom)) {
      pois.push({
        id: poi.id as number,
        lat: poi.coordinates?.lat as number,
        lon: poi.coordinates?.lon as number,
        type: MapPointTypes.poi,
        poiType: 'custom',
      });
    }

    return pois;
  }, [] as IDataItem[]);
}
